import React, { useRef, useState, useEffect, useMemo } from "react";
import {
  Row,
  Col,
  Table,
  Spin,
  Select,
  DatePicker,
  Space,
  Form,
  message,
} from "antd";
import { Pie } from "@ant-design/plots";
import Button from "atoms/Button";
import moment from "moment";
import styled from "@emotion/styled";
import { CSVLink } from "react-csv";
import { connect } from "react-redux";
import {
  getUserRoleId,
  getSelectedDepartmentId,
  getAllDepartmentList,
  getLeaveCategoryList,
  getShiftTimeMaster,
  getClientid,
  getUserInfo,
  getUserList,
  getMenuList,
} from "redux/selectors";
import { bindActionCreators } from "redux";
import { toggleProcessingModal } from "redux/actions";

import { CALL_API } from "common/API";
import {
  MONTH_LIST,
  REPORT_DURATION_TYPES,
  STATUS_CODE,

} from "common/Constants";

import {
  addDaysinDate,
  dateInDetail,
  getKenyanDateTime,
  getMonthDateRange,
  getMySqlDate,
  momentDate,
  addMonthinDate,
} from "utils/Date";
import COLORS from "common/Colors";
import { includes, reduce, concat, find, get, filter, uniqBy } from "lodash";
import ViewMore from "organisms/ViewMore";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";

const StyledTable = styled(Table)`
  padding-top: 20px;
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }
  table {
    width: 100% !important;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .ant-table-cell:nth-last-child(2) {
    min-width: 200px;
    white-space: normal;
  }
  .non-white {
    background: #f9f9f9;
  }
`;

const StyledSearchForm = styled(Form)`
  .ant-form-item-with-help {
    margin-bottom: 0px;
    .ant-form-item-explain-connected {
      display: none;
    }
  }
  .ant-form-item {
    display: inline-block;
    margin-right: 10px;
  }
  .outer-form {
    margin-right: 0px;
  }
  .ant-select-selector,
  .ant-picker,
  .ant-select,
  .ant-select-dropdown,
  .ant-select-dropdown-menu-item,
  .ant-select-dropdown-menu-item-group {
    width: 160px !important; // Updated from 150px to 160px
    width: 180px !important; // Updated width for country filter
  }
    .ant-btn.ant-btn-default.ant-dropdown-trigger.w-100.mb-3.custom-filter-btn {
  width: 180px !important;
}
`;
const StyledButton = styled(Button)`
  width: 120px;
  border: 1px solid ${COLORS.PRIMARY};
  color: ${COLORS.PRIMARY};
  width: initial;
  background: transparent;
  border-radius: 5px;
`;

const StyledChartCol = styled(Col)`
  width: 100%;
  padding: 40px 10px 10px 10px;
`;
const StyledButtonoutlined = styled(ButtonOutlined)`
  @media(max-width:900px){
margin-left:-20px !important;}
  @media (max-width: 768px) {
    margin-left: -20px !important;
    margin-top: -1px !important;
  }
  @media (max-width: 575px) {
    margin-left: 0 !important;
    position: absolute;
    left: 0;
    margin-top: -1px;
  }
`;
function LeaveReport({
  userRoleId,
  leaveCategoryList,
  allDepartmentList,
  selectedDepartmentId,
  ClientId,
  userInfo,
  userList,
  menuList, // Added menuList
}) {
  const [leaveList, setLeaveList] = useState([]);
  const [staffLeaveList, setStaffLeaveList] = useState([]);
  const [CSVLeaveList, setCSVLeaveList] = useState([]);
  const [displayTableLoader, setDisplayTableLoader] = useState(false);
  const [approvedLeaves, setApprovedLeaves] = useState(0);
  const [pendingLeaves, setPendingLeaves] = useState(0);
  const [selectedLeaveTypes, setSelectedLeaveTypes] = useState([]);
  const [selectedStaffNames, setSelectedStaffNames] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [expandedReasons, setExpandedReasons] = useState("");
  const containerRef = useRef(null);
  const csvLinkEl = useRef();
  const [form] = Form.useForm();
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [filteredUserIds, setFilteredUserIds] = useState([]);
  const [getFilterData, setGetFilterData] = useState([])
  const [filteredCountries, setFilteredCountries] = useState([]);

  const [originalLeaveList, setOriginalLeaveList] = useState([]);
  const isChairman = userInfo.higherOfficialsList.some(
    (official) => official.role === "CHAIRMAN" && official.email === userInfo.userid
  );
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0]; // Added Menulist logic
  console.log("selectedLeaveTypes----->", selectedLeaveTypes)
  const finduser = userList?.find((val) => val?.userid === userInfo?.userid);
  const nationality = finduser?.nationality;
  const userId = isChairman
    ? userList.map((user) => user.userid)
    : userList.filter((user) => user.nationality?.includes(nationality)).map((user) => user.userid);
  const handleLeaveTypeChange = () => {
    const values = form.getFieldsValue();
    setSelectedLeaveTypes(values.leave_type?.map(String) || []); // Ensure values are strings
  };
  const countryList = userList
    .filter(user => leaveList.some(attendance => attendance.userid === user.userid))
    .map(user => user.nationality);

  const handleStaffNameChange = () => {
    const values = form.getFieldsValue();
    setSelectedStaffNames(values.staff_name || []);
  };

  // const handleCountryFilterChange = () => {
  //   const values = form.getFieldsValue();
  //   setSelectedCountries(values.country || []);
  // };

  // useEffect(() => {
  //   let result = leaveList;
  //   console.log("leaveList1111--->", leaveList)
  //   const filter = leaveList.filter((data) => {
  //     if (data.leave_category_id) {
  //       const find = selectedLeaveTypes.filter((val) => String(val) === String(data.leave_category_id));
  //       return find;
  //     }
  //   })

  //   console.log("filter1111--->", filter)
  // }, [selectedLeaveTypes])

  useEffect(() => {
    let result = leaveList;

    // Filter by leave types
    if (selectedLeaveTypes?.length > 0) {
      const cleanLeaveTypes = selectedLeaveTypes.map(type => String(type).trim());

      result = result.filter(data => {
        const leaveId = String(data?.leave_category_id).trim();

        const isMatch = cleanLeaveTypes.some(type => type === leaveId);
        console.log(`Checking leaveId ${leaveId} against`, cleanLeaveTypes, '→', isMatch);

        return isMatch;
      });
    }

    // Filter by employee names
    if (selectedStaffNames.length > 0 && !selectedStaffNames.includes("")) {
      result = result.filter((data) =>
        selectedStaffNames.includes(data.userid)
      );
    }

    // Filter by countries
    if (filteredCountries.length > 0) {
      const filteredUsers = userList.filter((user) =>
        filteredCountries.includes(user.nationality)
      );
      const userIds = filteredUsers.map((user) => user.userid);
      result = result.filter((data) => userIds.includes(data.userid));
    }

    setFilterList(result);
  }, [selectedLeaveTypes, selectedStaffNames, filteredCountries, leaveList, originalLeaveList]);

  // useEffect(() => {
  //   const filteredUsers = leaveList.filter((user) =>
  //     selectedCountries.some((country) => user.nationality === country)
  //   );
  //   const userIds = filteredUsers.map((user) => user.userid);
  //   setFilteredUserIds(userIds);
  // }, [selectedCountries]);

  useEffect(() => {
    if (filterList?.length > 0) {

    }
  })

  const handleCountryFilterChange = () => {
    const values = form.getFieldsValue();
    setFilteredCountries(values.country || []);
  };
  console.log("userList--->", userList)
  useEffect(() => {
    console.log("filteredCountries-->", filteredCountries)
    if (filteredCountries.length === 0) {
      setFilteredUserIds([]); // Reset if no filter is selected
      return;
    }

    const filteredUsers = userList.filter(user => {
      return filteredCountries.some(country => user.nationality === country)
    });

    const userIds = filteredUsers.map(user => user.userid || user.userId) || [];
    setFilteredUserIds(userIds);
    setGetFilterData(filteredUsers);
    console.log("UserIDs:", userIds);
    console.log("filteredUsers:", filteredUsers);
  }, [filteredCountries]);
  console.log("filteredUserIds--->", filteredUserIds)
  // API Call (Ensure it happens after filteredUserIds updates)
  useEffect(() => {
    if (filteredUserIds.length > 0) {
      getLeaveList();
    }
  }, [filteredUserIds]);

  const STAFF_LIST_ALL = leaveList.map((val) => {
    return { value: val.userid, label: val.name };
  });

  const STAFF_LIST = [...new Set(STAFF_LIST_ALL.map((a) => JSON.stringify(a)))].map(
    (a) => JSON.parse(a)
  );
  const ALL = [{ value: "*", label: "All Employees" }];
  const CSVHeaders = [
    { label: "Employee ID", key: "user_id" },
    { label: "Name", key: "name" },
    { label: "Department", key: "job_title_name" },
    { label: "Start Date", key: "start_date" },
    { label: "End Date", key: "end_date" },
    { label: "Days", key: "days" },
    { label: "Leave Type", key: "leave_category_name" },
    { label: "Status", key: "status" },
  ];

  const columns = [
    {
      title: "Employee ID",
      dataIndex: "employeeid",
      key: "employeeid",
      width: "8%",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "12%",
    },
    {
      title: "Department",
      dataIndex: "department_name",
      key: "department_name",
      width: "10%",
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      width: "7%",
      sorter: (a, b) => (
        moment(a.start_date).format("DD"),
        moment(a.start_date).format("MM"),
        moment(a.start_date).format("YYYY") - moment(b.start_date).format("DD"),
        moment(b.start_date).format("MM"),
        moment(b.start_date).format("YYYY")
      ),
      render: (date) => {
        const dateFormat = moment(date).format("DD MMM YYYY");
        return `${dateFormat}`;
      },
    },
    {
      title: "Start Day",
      dataIndex: "start_date",
      key: "start_date",
      width: "7%",
      render: (date) => {
        const getdayAlone = moment(date).format("dddd");
        return `${getdayAlone}`;
      },
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      width: "7%",
      render: (date) => {
        const dateFormat = moment(date).format("DD MMM YYYY");
        return `${dateFormat}`;
      },
    },
    {
      title: "End Day",
      dataIndex: "end_date",
      key: "end_date",
      width: "10%",
      render: (date) => {
        const getdayAlone = moment(date).format("dddd");
        return `${getdayAlone}`;
      },
    },
    {
      title: "Days",
      dataIndex: "number_of_days",
      key: "number_of_days",
      width: "7%",
    },
    {
      title: "Leave Type",
      dataIndex: "leave_category_name",
      key: "leave_category_name",
      width: "10%",
    },

    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      width: "15%",

      render: (date, record) => {
        return (
          <>
            <ViewMore value={`${record.reason}${record.decline_reason}`} />
          </>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status_name",
      key: "status_name",
      // width: '7%',
      align: "center",
    },
  ];

  // if (userRoleId === 1) {
  //   columns.splice(2, 0, {
  //     title: 'Department',
  //     dataIndex: 'job_title_name',
  //     key: 'job_title_name',
  //     width: '10%',
  //     align: 'center'
  //   })
  // }

  const data = [
    {
      type: "Approved",
      value: approvedLeaves,
    },
    {
      type: "Pending",
      value: pendingLeaves,
    },
  ];
  const config = {
    width: 150,
    height: 150,
    appendPadding: 6,
    data,
    angleField: "value",
    colorField: "type",
    color: [COLORS.CHART.AVAILABLE, COLORS.CHART.CONSUMED],
    radius: 1,
    innerRadius: 0.8,
    legend: {
      position: "top",
    },
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontSize: "14px",
        },
        content: `${approvedLeaves}/${pendingLeaves}`,
      },
    },
  };

  useEffect(() => {
    getLeaveList();
  }, [
    selectedDepartmentId,
    userRoleId,
    form.getFieldValue("duration_type"),
    form.getFieldValue("start_date"),
    form.getFieldValue("end_date"),
    form.getFieldValue("month"),
    form.getFieldValue("department"),
    // selectedLeaveTypes,
    selectedStaffNames,
    selectedCountries,
  ]);

  const getLeaveList = async () => {
    setLeaveList([]);
    const {
      start_date,
      end_date,
      duration_type,
      month,
      department,
    } = form.getFieldsValue();
    setDisplayTableLoader(true);
    const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
      dateInDetail(getKenyanDateTime()).year,
      get(find(MONTH_LIST, { value: month }), "index", 0)
    );
    const emailList = userInfo.higherOfficialsList.map(official => official.email.toLowerCase());

    // Check if the user is in the higher officials list
    const isPrivilegedUser = emailList.includes(userInfo.userid.toLowerCase());

    const payload = {
      department_id: [""],
      leave_type: "",
      // leave_type: selectedLeaveTypes,
      status_id: "4,5",
      start_date: getMySqlDate(
        duration_type === 2 ? startDateOfMonth : start_date
      ),
      end_date: getMySqlDate(
        duration_type === 2 ? lastDateOfMonth : end_date
      ),
      reportingmanager: isChairman
        ? ""
        : isPrivilegedUser
          ? ""
          : userInfo?.userid,
      userIds: isChairman
        ? []
        : isPrivilegedUser
          ? userId
          : filteredUserIds,
    };



    const { code, leaves = [] } = await CALL_API(
      `leave-report/${ClientId}`,
      "post",
      payload

    );
    setDisplayTableLoader(false);
    if (includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)) {
      setLeaveList(leaves.reverse());
      setOriginalLeaveList(leaves.reverse());
      setStaffLeaveList(leaves.reverse());
      setPendingLeaves(filter(leaves, { status_id: "4" }).length);
      setApprovedLeaves(filter(leaves, { status_id: "5" }).length);
    }
  };

  const validateDateRange = (date) => {
    const endDate = moment(form.getFieldValue("end_date"));
    if (endDate < date) {
      form.setFieldsValue({ end_date: date });
    }
  };

  const prepareCSV = async (event, done) => {
    if (leaveList.length > 0) {
      setCSVLeaveList(
        reduce(
          leaveList,
          function (result, leave) {
            const {
              date_th: end_day,
              shortMonthName: end_shortMonthName,
              year: end_year,
              longDay: end_longDay,
            } = dateInDetail(leave.end_date);
            const {
              date_th: start_day,
              shortMonthName: start_shortMonthName,
              year: start_year,
              longDay: start_longDay,
            } = dateInDetail(leave.start_date);
            result.push({
              "Employee ID": leave.employeeid,
              Name: leave.name,
              Department: leave.department_name,
              "Start Date": `${start_day} ${start_shortMonthName} ${start_year}`,
              "Start Day": `${moment(leave.start_date).format("dddd")}`,
              "End Date": `${end_day} ${end_shortMonthName} ${end_year}`,
              "End Day": `${moment(leave.end_date).format("dddd")}`,
              Days: leave.number_of_days,
              "Leave Type": leave.leave_category_name,
              Reason: leave.reason,
              Status: leave.status_name,
            });
            return result;
          },
          []
        )
      );

      setTimeout(() => {
        csvLinkEl.current.link.click();
      });
    } else {
      message.error(`No data available to download.`);
    }
  };

  const paginationOptions = {
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize: 100,
    showSizeChanger: false,
  };

  const uniqueLeaveTypes = uniqBy(
    leaveCategoryList.map((category) => ({
      label: category.leave_category_name,
      value: category.leave_category_id,
    })),
    "value"
  );


  const uniqueEmployeeNames = uniqBy(
    STAFF_LIST?.map((item) => {
      return {
        label: item.label,
        value: item.value,
      };
    }),
    "value"
  );

  const uniqueCountryName = uniqBy(
    countryList?.map((item) => {
      return {
        label: item,
        value: item,
      };
    }),
    "value"
  );

  return (
    <>
      <Row className="page-title">
        <Col
          xs={24}
          sm={19}
          md={19}
          className="page-title-head"
          ref={containerRef}
        >
          <Space>
            <StyledSearchForm className="custom_form_design"
              form={form}
              name="approval_form"
              layout="inline"
              initialValues={{
                duration_type: 2,
                month: dateInDetail(getKenyanDateTime()).monthName,
                start_date: momentDate(addMonthinDate(getKenyanDateTime(), -1)),
                end_date: momentDate(addDaysinDate(getKenyanDateTime())),
                department: "",
                leave_type: [],
                staff_name: [],
                country: [],
              }}
              onValuesChange={(changedValues) => {
                handleLeaveTypeChange();
                handleStaffNameChange();
                handleCountryFilterChange();
                if (changedValues && !changedValues.leave_type) {
                  console.log("changedValues--->", changedValues)
                  getLeaveList()
                }
              }}
              onFinish={getLeaveList}
            >
              <Form.Item
                name="duration_type"
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <Select className="custom_form_design"
                  placeholder="Select..."
                  options={REPORT_DURATION_TYPES}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>

              <Form.Item className="outer-form" shouldUpdate>
                {({ getFieldValue }) => {
                  const duration_type = getFieldValue("duration_type");
                  return duration_type === 1 ? (
                    <>
                      <Form.Item
                        name="start_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="Start date"
                          format="DD-MM-YYYY"
                          style={{ borderRadius: '20px' }}
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>

                      <Form.Item
                        name="end_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="End date"
                          format="DD-MM-YYYY"
                          style={{ borderRadius: '20px' }}
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </>
                  ) : (
                    <Form.Item
                      name="month"
                      rules={[
                        {
                          required: true,
                          message: "",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select..."
                        options={MONTH_LIST}
                        getPopupContainer={() => containerRef.current}
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>

              {(userRoleId === 1 || userRoleId === 6) && (
                <Form.Item name="department">
                  <Select
                    placeholder="Select Department"
                    options={concat(
                      {
                        department_id: "",
                        department_name: "All Departments",
                      },
                      allDepartmentList
                    )}
                    fieldNames={{
                      label: "department_name",
                      value: "department_id",
                    }}
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              )}

              <Form.Item name="leave_type">
                <DropdownCheckBox
                  name="leave_type"
                  label="Leave Type"
                  options={uniqueLeaveTypes}
                  form={form}
                  handleFormChange={handleLeaveTypeChange}
                  allowClear={true}

                />
              </Form.Item>
              <Form.Item name="staff_name">
                <DropdownCheckBox
                  name="staff_name"
                  label="Select Employee"
                  options={uniqueEmployeeNames}
                  form={form}
                  handleFormChange={handleStaffNameChange}
                  allowClear={true}
                />
              </Form.Item>
              {
                // Menulist?.find(
                //   (item) =>
                //     item?.key === "countryfilter" &&
                //     item?.permission.view
                // )
                isChairman
                && (
                  <Form.Item name="country">
                    <DropdownCheckBox
                      name="country"
                      label="Country"
                      options={uniqueCountryName}
                      clearFunction={getLeaveList}
                      form={form}
                      handleFormChange={handleCountryFilterChange}
                    />
                  </Form.Item>
                )}
            </StyledSearchForm>
          </Space>
        </Col>
        <Col xs={24} sm={4} md={4} className="align-right">
          <StyledButtonoutlined
            onClick={prepareCSV}
            disabled={leaveList.length === 0}
          >
            Export CSV file
          </StyledButtonoutlined>
          <CSVLink
            header={CSVHeaders}
            data={CSVLeaveList}
            filename={"leave-report.csv"}
            asyncOnClick={true}
            ref={csvLinkEl}
          />
        </Col>
      </Row>
      <br />
      {/* {approvedLeaves > 0 && pendingLeaves > 0 && (
        <Row>
          <StyledChartCol>
            <Pie {...config} />
          </StyledChartCol>
        </Row>
      )} */}
      <Spin spinning={displayTableLoader}>
        <StyledTable
          dataSource={filterList}
          columns={columns}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="user_leave_id"
          pagination={filterList.length > 100 ? paginationOptions : false}
        />
      </Spin>
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  allDepartmentList: getAllDepartmentList(state),
  leaveCategoryList: getLeaveCategoryList(state),
  shiftTimeMaster: getShiftTimeMaster(state),
  ClientId: getClientid(state),
  userInfo: getUserInfo(state),
  userList: getUserList(state),
  menuList: getMenuList(state), // Added menuList
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateProcessingModal: toggleProcessingModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(LeaveReport);
